import * as React from 'react';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

const CustomListItemAvatar = (props) => {
    return <ListItemAvatar {...props} />;
};

export { CustomListItemAvatar as ListItemAvatar };
